import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { links } from "../../utils/link";

const NavLinks = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  let timeoutId = null;

  const handleMouseEnter = () => {
    clearTimeout(timeoutId); // Prevent hiding if the mouse enters again
    setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    timeoutId = setTimeout(() => {
      setShowDropdown(false);
    }, 500); // Dropdown hides after 0.5 seconds for better UX
  };

  return (
    <div className="flex flex-col md:flex-row lg:gap-10 2xl:gap-20">
      {links.map((link, index) => (
        <div
          key={index}
          className="relative group"
          onMouseEnter={() => link.submenu && handleMouseEnter()}
          onMouseLeave={() => link.submenu && handleMouseLeave()}
        >
          {/* Main Link */}
          <Link
            to={link.link}
            className="no-underline tracking-wider text-gray-800 hover:text-blue-600 text-[18px] font-medium relative group-hover:after:w-full after:absolute after:left-0 after:bottom-[-4px] after:h-[2px] after:bg-blue-600 after:w-0 after:transition-all after:duration-300"
          >
            {link.name}
          </Link>

          {/* Dropdown Menu for Cities */}
          {link.submenu && showDropdown && (
            <div 
              className="absolute mt-3 bg-white shadow-lg rounded-md border border-gray-100 z-50 transform transition-all duration-300 ease-in-out w-64"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <ul className="pl-0 py-1">
                {/* Mumbai with image 1 */}
                <li className="border-b border-gray-50">
                  <Link
                    to="/location/mumbai"
                    className="flex items-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-blue-50 no-underline transition-all duration-200"
                  >
                    <img 
                      src="/homepage/navbar-images/1.jpeg" 
                      alt="Mumbai" 
                      className="w-10 h-10 mr-3 object-cover rounded" 
                    />
                    <span className="font-medium text-[15px]">Mumbai</span>
                  </Link>
                </li>
                
                {/* Pune with image 2 */}
                <li className="border-b border-gray-50">
                  <Link
                    to="/location/pune"
                    className="flex items-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-blue-50 no-underline transition-all duration-200"
                  >
                    <img 
                      src="/homepage/navbar-images/2.jpeg" 
                      alt="Pune" 
                      className="w-10 h-10 mr-3 object-cover rounded" 
                    />
                    <span className="font-medium text-[15px]">Pune</span>
                  </Link>
                </li>
                
                {/* Bangalore with image 3 */}
                <li className="border-b border-gray-50">
                  <Link
                    to="/location/bengaluru"
                    className="flex items-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-blue-50 no-underline transition-all duration-200"
                  >
                    <img 
                      src="/homepage/navbar-images/3.jpeg" 
                      alt="Bangalore" 
                      className="w-10 h-10 mr-3 object-cover rounded" 
                    />
                    <span className="font-medium text-[15px]">Bangalore</span>
                  </Link>
                </li>
                
                {/* Gurugram with image 4 */}
                <li className="border-b border-gray-50 last:border-b-0">
                  <Link
                    to="/location/gurugram"
                    className="flex items-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-blue-50 no-underline transition-all duration-200"
                  >
                    <img 
                      src="/homepage/navbar-images/4.png" 
                      alt="Gurugram" 
                      className="w-10 h-10 mr-3 object-cover rounded" 
                    />
                    <span className="font-medium text-[15px]">Gurugram</span>
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NavLinks;
